const locale_key = 'CONFIRM_BOOKING.ERROR_CLIENT_LOCATOR_MESSAGE';
export const values = {
    'b2bweberoski': {
        validateClientLocator: true,
        errorMessageClientLocator: locale_key
    },
    'b2bwebdawson': {
        validateClientLocator: true,
        errorMessageClientLocator: locale_key
    },
    'b2bwebolympia': {
        validateClientLocator: true,
        errorMessageClientLocator: locale_key
    },
    'default': {
        validateClientLocator: false,
        errorMessageClientLocator: ''
    }
};


// WEBPACK FOOTER //
// ./src/components/Reservation/Validators/ClientLocatorData.js